import { render } from "./asides.vue?vue&type=template&id=5218ac42"
import script from "./asides.vue?vue&type=script&lang=js"
export * from "./asides.vue?vue&type=script&lang=js"

import "./asides.vue?vue&type=style&index=0&id=5218ac42&lang=css"

import exportComponent from "/Users/yunusemresogut/Desktop/ishesap-partner/bayi_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__